import React, {useState, useEffect} from "react";
import PdfStudy from '@/components/pdf'

const Index = ({location}) => {
  const [query, setQuery] = useState()

  useEffect(() => {
    setQuery(new URLSearchParams(location.search))
  }, [location.search])


  return query?.get('src') ? <PdfStudy url={query?.get('src')} /> : '';
}

export default Index
